//export const baseUrl = 'http://localhost:9090/';
export const baseUrl = 'https://erp.choqorak.com/';
